<!--  -->
<template>
  <div>
    <div class="dialog-content">
      <div style="width: 25%">
        <div>
          <el-input v-model="query.account_id" style="width:250px;margin-right: 10px" placeholder="请输入广告账户id" />
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="info" @click="reset">重置</el-button>
          <el-button type="primary" @click="clearAll">清空选项</el-button>
        </div>
        <el-table
          style="margin-top: 10px;"
          :data="account_list"
          height="700px"
          border
        >
          <el-table-column
            prop="id"
            fixed
            label="id"
            width="120px"
          >
            <template slot="header">
              <!-- 自定义表头，放置全选按钮 -->
              <el-button style="width: 100%;height: 100%" type="text" @click="selectAllRows">全选</el-button>
            </template>
            <template slot-scope="scope">
              <el-checkbox
                v-model="selectedRows"
                :label="scope.row.id"
                @change="handleCheckChange(scope.row,$event)"
              />
            </template>
          </el-table-column>
          <el-table-column label="广告主id" align="center" width="100" prop="account_id" />
          <el-table-column label="广告主名称" align="center" prop="account_name" />
          <el-table-column label="备注" align="center" width="100" prop="remark" />
          <el-table-column label="账户状态" width="100" align="center" prop="account_status_text" />
          <!--        <el-table-column width="130px" label="复制的量">-->
          <!--          <template slot-scope="scope">-->
          <!--            <el-input-->
          <!--              v-model="scope.row.num"-->
          <!--              :class="{ 'hidden-input': !selectedRows.includes(scope.row.id) }"-->
          <!--              placeholder="请输入数量"-->
          <!--              type="number"-->
          <!--              @input="handleQuantityChange(scope.row)"-->
          <!--            />-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <!--        <el-table-column width="130px" label="原生页处理">-->
          <!--          <template slot-scope="scope">-->
          <!--            <el-select v-model="scope.row.pages_handle" placeholder="请选择" :class="{ 'hidden-input': !selectedRows.includes(scope.row.id)}">-->
          <!--              <el-option-->
          <!--                v-for="option in pageHandleSelectOptions"-->
          <!--                :key="option.value"-->
          <!--                :label="option.label"-->
          <!--                :value="option.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <!--        <el-table-column width="100px" label="备注">-->
          <!--          <template slot-scope="scope">-->
          <!--            <el-input-->
          <!--              v-model="scope.row.remark"-->
          <!--              :class="{ 'hidden-input': !selectedRows.includes(scope.row.id) }"-->
          <!--              placeholder="请输入备注"-->
          <!--              @input="handleRemarkChange(scope.row)"-->
          <!--            />-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <!--        <el-table-column width="180px" label="开始时间">-->
          <!--          <template slot-scope="scope">-->
          <!--            <el-date-picker-->
          <!--              v-model="scope.row.begin_time"-->
          <!--              :class="{ 'hidden-input': !selectedRows.includes(scope.row.id) }"-->
          <!--              type="date"-->
          <!--              value-format="yyyy-MM-dd"-->
          <!--              placeholder="选择开始日期"-->
          <!--              :picker-options="pickerOptions"-->
          <!--              @change="handleStartDateChange(scope.row)"-->
          <!--            />-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <!--        <el-table-column width="180px" label="结束时间">-->
          <!--          <template slot-scope="scope">-->
          <!--            <el-date-picker-->
          <!--              v-model="scope.row.end_time"-->
          <!--              value-format="yyyy-MM-dd"-->
          <!--              :class="{ 'hidden-input': !selectedRows.includes(scope.row.id)}"-->
          <!--              type="date"-->
          <!--              :disabled="!scope.row.begin_time"-->
          <!--              placeholder="选择结束日期"-->
          <!--              :disabled-date="(date) => disabledEndDate(date, scope.row.begin_time)"-->
          <!--              :picker-options="{ disabledDate: (date) => disabledEndDate(date, scope.row.begin_time) }"-->
          <!--            />-->
          <!--          </template>-->
          <!--        </el-table-column>-->
        </el-table>
      </div>
      <div style="width: 75%">
        <div style="display:flex;align-items: center;margin-bottom:20px;flex-wrap: wrap;max-height:100px;overflow-y: auto;">
          <!-- <div>投放推广内容资产：</div> -->

          <el-button
            type="primary"
            size="mini"
            style="margin-right:10px"
            @click="chorwe"
          >选择投放推广内容资产<span v-if="appdir.length!=0" style="margin-left:10px">已选：{{ appdir.length }}个</span></el-button>
          <el-tag
            v-for="itemr,index in appdir"
            :key="index"
            style="margin-right:10px;margin-bottom:5px"
            closable
            @close="rightclick(index)"
          >
            {{ itemr.marketing_asset_name }}
          </el-tag>
        </div>
        已选: {{ commit_list.length }}
        <el-table
          :data="commit_list"
          style="margin-top: 10px"
          border
          height="500px"
        >
          <el-table-column width="80px" label="广告主id" prop="account_id" />
          <el-table-column width="120px" label="广告主名称" prop="account_name" />
          <el-table-column width="80px" label="账户状态" prop="account_status_text" />
          <el-table-column
            prop="num"
            label="复制数量"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.num" type="number" placeholder="请输入数字" />
            </template>
          </el-table-column>
          <el-table-column
            prop="delay_min"
            label="最小延时区间"
          >
            <template slot-scope="scope">
              <!-- <el-input v-model="scope.row.delay_min" type="number" placeholder="请输入数字" /> -->
              <!-- <el-input-number size="mini" v-model="scope.row.delay_min" @blur="smaill(scope.row)" :min="0" :max="100" label="请输入数字"></el-input-number> -->
              <el-input v-model="scope.row.delay_min" class="a" type="number" :min="0" :max="100" placeholder="请输入内容" @input="numValid(scope.row)" @blur="smaill(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="delay_max"
            label="最大延时区间"
          >
            <template slot-scope="scope">
              <!-- <el-input v-model="scope.row.delay_max" type="number" placeholder="请输入数字" /> -->
              <!-- <el-input-number size="mini" v-model="scope.row.delay_max" @blur="maxill(scope.row)" :min="0" :max="100" label="请输入数字"></el-input-number> -->
              <el-input v-model="scope.row.delay_max" class="a" type="number" :min="0" :max="100" placeholder="请输入内容" @input="numValidmax(scope.row)" @blur="maxill(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入备注" />
            </template>
          </el-table-column>
          <el-table-column
            label="素材MD5"
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.is_alter_md5" placeholder="请选择">
                <el-option
                  v-for="option in md5Options"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <el-popover
                placement="top-start"
                width="500"
                trigger="hover"
              >
                <span slot="reference" class="header-popover">
                  落地页处理 <i class="el-icon-warning-outline" />
                </span>
                <div>
                  落地页处理类型
                  <p>授权：目标账户使用授权的落地页</p>
                  <p>创建（同账户）：单个账户中落地页唯一</p>
                  <p>创建（同任务）：同任务中，首条创建，其余复用</p>
                  <p>创建（同记录）：任务中每条记录都创建，慎用</p>
                  <p>注：官方落地页无授权，默认为创建（同账户）</p>
                </div>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.pages_handle">
                <el-option
                  v-for="option in pages_handles"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="广告状态"
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.is_close" placeholder="请选择">
                <el-option
                  v-for="option in ad_options"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="begin_time"
            label="推广开始日期"
          >
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.begin_time"
                placeholder="选择开始日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="推广结束日期"
          >
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.end_time"
                type="date"
                :disabled="!scope.row.begin_time"
                placeholder="选择结束日期"
                value-format="yyyy-MM-dd"
                :disabled-date="(date) => disabledEndDate(date, scope.row.begin_time)"
                :picker-options="{ disabledDate: (date) => disabledEndDate(date, scope.row.begin_time) }"
              />
            </template>
          </el-table-column>
        </el-table>
        <h3 style="margin-bottom: 4px;">通用改动：此改动会影响全局</h3>
        <el-table
          :data="all_list"
          style="margin-top: 10px"
          border
        >
          <el-table-column
            prop="num"
            label="复制数量"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.num" type="number" placeholder="请输入数字" @input="AllTableChange(scope.row.num, 1)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="delay_min"
            label="最小延时区间"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.delay_min" type="number" placeholder="数字（范围0-100）" @input="AllTableChange(scope.row.delay_min, 8)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="delay_max"
            label="最大延时区间"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.delay_max" type="number" placeholder="数字（范围0-100）" @input="AllTableChange(scope.row.delay_max, 9)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入备注" @input="AllTableChange(scope.row.remark, 2)" />
            </template>
          </el-table-column>
          <el-table-column
            label="素材MD5"
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.is_alter_md5" placeholder="请选择" @change="AllTableChange(scope.row.is_alter_md5, 6)">
                <el-option
                  v-for="option in md5Options"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="落地页处理"
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.pages_handle" placeholder="请选择" @change="AllTableChange(scope.row.pages_handle, 11)">
                <el-option
                  v-for="option in pages_handles"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="广告状态"
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.is_close" placeholder="请选择" @change="AllTableChange(scope.row.is_close, 10)">
                <el-option
                  v-for="option in ad_options"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="开始时间">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.begin_time"
                placeholder="选择开始日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="AllTableChange(scope.row.begin_time, 3)"
              />
            </template>
          </el-table-column>
          <el-table-column label="结束时间">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.end_time"
                type="date"
                :disabled="!scope.row.begin_time"
                placeholder="选择结束日期"
                value-format="yyyy-MM-dd"
                :disabled-date="(date) => disabledEndDate(date, scope.row.begin_time)"
                :picker-options="{ disabledDate: (date) => disabledEndDate(date, scope.row.begin_time) }"
                @change="AllTableChange(scope.row.end_time, 4)"
              />
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right; margin: 20px">
          <el-button type="info" @click="$emit('close')">取消</el-button>
          <el-button type="success" @click="jobCreated">提交复制</el-button>
        </div>
      </div>
    </div>
    <pagination-right
      style="justify-content: left;"
      :current-page="query.page"
      :total="total"
      :page-sizes="[100,200]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      title="投放推广内容资产"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import Vue from 'vue'
import { advertiserList } from '@/api/customer'
import bandstaff from './bandstaff.vue'
export default {
  components: {
    PaginationRight,
    bandstaff
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop,vue/prop-name-casing
    commit_type: {
      type: String
    }
  },
  data() {
    return {
      account_list: [],
      total: null,
      query: {
        page: 1,
        page_size: 100,
        account_id: null
      },
      commit_list: [],
      selectedRows: [],
      quantity: null,
      endDate: null,
      startDate: null,
      configInfo: false,
      all_list: [{
        num: null,
        begin_time: null,
        end_time: null,
        remark: null,
        onlineUrl: null,
        delay_min: null,
        delay_max: null
      }],
      urlData: null,
      pageHandleSelectOptions: [
        { label: '授权', value: 1 },
        { label: '创建', value: 2 }
      ],
      md5Options: [
        { label: '修改', value: 1 },
        { label: '不修改', value: 0 }
      ],
      pages_handles: [
        { label: '授权', value: 1 },
        // { label: '创建(同账号)', value: 2 },
        { label: '创建(同任务)', value: 3 }
        // { label: '创建(同记录)', value: 4 }
      ],
      correction_options: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      ad_options: [
        { label: '关闭', value: 1 },
        { label: '开启', value: 0 }
      ],
      appdir: [],
      chuanappid: [],
      dialogVisibler: false,
      newaccount_id: null,
      marketing_target_type: null
    }
  },
  computed: {
    pickerOptions() {
      return {
        // 禁用今天之前的日期
        disabledDate: (time) => {
          const today = new Date()
          return time.getTime() < today.setHours(0, 0, 0, 0) // 今天之前的日期不可选
        }
      }
    },
    isSelectAll() {
      return this.account_list.length > 0 && this.account_list.every(row => this.selectedRows.includes(row.id))
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    list() {
      this.isLoading = true
      advertiserList(this.query).then(res => {
        this.account_list = res.data.list
        this.total = res.data.total
        this.isLoading = false
      })
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    // 处理复选框变化
    handleCheckChange(row, type) {
      if (!type) {
        // eslint-disable-next-line eqeqeq
        this.commit_list = this.commit_list.filter(item => item.account_id != row.account_id)
      } else {
        Vue.set(row, 'num', 1)
        Vue.set(row, 'begin_time', new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0])
        Vue.set(row, 'end_time', new Date(new Date(new Date().setFullYear(new Date().getFullYear() + 1)).setDate(new Date().getDate() - 2)).toISOString().split('T')[0]
        )
        Vue.set(row, 'is_alter_md5', 0)
        Vue.set(row, 'is_fail_correction', 0)
        Vue.set(row, 'delay_min', 0)
        Vue.set(row, 'delay_max', 0)
        Vue.set(row, 'is_close', 1)
        Vue.set(row, 'pages_handle', 1)
        this.commit_list.push(row)
      }
    },
    handleQuantityChange(row) {
    },
    //
    handleRemarkChange(row) {
      //
    },
    handleStartDateChange(row) {
      //
    },
    disabledEndDate(date, startDate) {
      if (!startDate) {
        return false
      }
      const startDateTime = new Date(startDate).getTime()
      const minEndDateTime = startDateTime - 86400000
      return date.getTime() <= minEndDateTime
    },
    jobCreated() {
      this.chuanappid = []
      this.chuanappid = this.appdir.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.marketing_asset_id
      })
      this.$emit('jobCreated', this.commit_list, this.commit_type, this.chuanappid)
    },
    AllTableChange(val, type) {
      // 根据 type 进行不同的处理
      switch (type) {
        case 1:
          this.commit_list.forEach(item => {
            Vue.set(item, 'num', val)
          })
          break
        case 2:
          this.commit_list.forEach(item => {
            Vue.set(item, 'remark', val)
          })
          break
        case 3:
          this.commit_list.forEach(item => {
            Vue.set(item, 'begin_time', val)
          })
          break
        case 4:
          this.commit_list.forEach(item => {
            Vue.set(item, 'end_time', val)
          })
          break
        case 5:
          this.commit_list.forEach(item => {
            Vue.set(item, 'pages_handle', val)
          })
          break
        case 6:
          this.commit_list.forEach(item => {
            Vue.set(item, 'is_alter_md5', val)
          })
          break
        case 7:
          this.commit_list.forEach(item => {
            Vue.set(item, 'is_fail_correction', val)
          })
          break
        case 8:
          if (val > 100) {
            this.$message.error('数值范围为0-100')
            return
          }
          if (val < 0) {
            this.$message.error('数值范围为0-100')
            return
          }
          this.commit_list.forEach(item => {
            if (val > item.delay_max) {
              console.log('大')
              Vue.set(item, 'delay_min', val)
              Vue.set(item, 'delay_max', val)
            }
            if (val < item.delay_max) {
              console.log('小')
              Vue.set(item, 'delay_min', val)
            }
          })
          break
        case 9:
          if (val > 100) {
            this.$message.error('数值范围为0-100')
            return
          }
          if (val < 0) {
            this.$message.error('数值范围为0-100')
            return
          }
          console.log('val', val)
          this.commit_list.forEach(item => {
            if (val < item.delay_min) {
              Vue.set(item, 'delay_max', item.delay_min)
            } else {
              Vue.set(item, 'delay_max', val)
            }
          })
          break
        case 10:
          this.commit_list.forEach(item => {
            Vue.set(item, 'is_close', val)
          })
          break
        case 11:
          this.commit_list.forEach(item => {
            Vue.set(item, 'pages_handle', val)
          })
          break
        default:
          console.warn(`没有输入类型`)
      }
    },
    clearAll() {
      this.commit_list = []
      this.selectedRows = []
    },
    search() {
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.page_size = 10
      this.query.account_id = null
      this.clearAll()
      this.list()
    },
    selectAllRows() {
      if (this.isSelectAll) {
        this.account_list.forEach(row => {
          this.selectedRows = this.selectedRows.filter(item => item !== row.id)
          this.handleCheckChange(row, false)
        })
      } else {
        this.account_list.forEach(row => {
          if (!this.selectedRows.includes(row.id)) {
            this.selectedRows.push(row.id)
            this.handleCheckChange(row, true)
          }
        })
      }
    },
    smaill(item) {
      console.log(item)
      // eslint-disable-next-line eqeqeq
      if (item.delay_max == 0) {
        return
      }
      if (item.delay_min > item.delay_max) {
        item.delay_min = item.delay_max
      }
    },
    maxill(item) {
      console.log(item)
      if (item.delay_max < item.delay_min) {
        item.delay_max = item.delay_min
      }
    },
    numValid(value) {
      console.log('value', value)
      if (value.delay_min > 100) {
        value.delay_min = 100
      } else {
        value.delay_min = value.delay_min.replace(/[^0-9]/g, '')
      }
    },
    numValidmax(value) {
      console.log('value', value)
      if (value.delay_max > 100) {
        value.delay_max = 100
      } else {
        value.delay_max = value.delay_max.replace(/[^0-9]/g, '')
      }
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.appdir, this.newaccount_id, this.marketing_target_type)
      })
    },
    async bandarr(arr) {
      this.dialogVisibler = false
      this.appdir = arr
      console.log(arr)
    },
    sendr(newaccount_id, marketing_target_type) {
      console.log('newaccount_id', newaccount_id, marketing_target_type)
      this.newaccount_id = newaccount_id
      this.marketing_target_type = marketing_target_type
    },
    rightclick(index) {
      this.appdir.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.dialog-content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  height: 90%;
}
.hidden-input {
  visibility: hidden;
}
.input_popper {
  width: 300px;
  max-height: 500px;
}
</style>
